.contentHeaderRemoveAction {
	text-transform: none;
}

.contentHeaderDeleteIcon {
	float: right;
}
